import { Building2, Zap, GraduationCap, Landmark } from "lucide-react";

const industries = [
  {
    icon: Landmark,
    name: "Public Sector",
    description: "Delivering secure, compliant solutions for government organisations.",
  },
  {
    icon: Zap,
    name: "Utilities, Resources & Energy",
    description: "Streamlining operations for critical infrastructure and energy providers.",
  },
  {
    icon: GraduationCap,
    name: "Higher Education",
    description: "Enhancing service delivery and student experience for universities.",
  },
  {
    icon: Building2,
    name: "Enterprise",
    description: "Scalable platform solutions for complex, multi-department organisations.",
  },
];

export default function Industries() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="py-24 lg:py-32 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0047AB] mb-3">
            Industries
          </p>
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-900">
            Sectors We Serve
          </h2>
          <p className="mt-4 text-base text-slate-600 max-w-2xl mx-auto">
            Our curated team has worked across a range of industries, bringing proven
            insights and practical solutions to complex environments.
          </p>
        </div>

        {/* Industries Row */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map((ind) => {
            const Icon = ind.icon;
            return (
              <div
                key={ind.name}
                data-testid={`industry-card-${ind.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="group bg-white border border-slate-200 rounded-lg p-6 transition-all duration-300 hover:border-[#0047AB] hover:-translate-y-1"
              >
                <div className="w-10 h-10 rounded-md bg-[#DBEAFE] flex items-center justify-center mb-4 group-hover:bg-[#0047AB] transition-colors duration-300">
                  <Icon
                    size={20}
                    className="text-[#0047AB] group-hover:text-white transition-colors duration-300"
                  />
                </div>
                <h3 className="text-base font-semibold text-slate-900 mb-2">
                  {ind.name}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed">
                  {ind.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
